var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#0077B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 13.5H14.9531C14.1562 13.5 13.5 14.2031 13.5 15.0469V33C13.5 33.8438 14.1562 34.5 14.9531 34.5H33C33.7969 34.5 34.5 33.8438 34.5 33V15.0469C34.5 14.2031 33.7969 13.5 33 13.5ZM19.8281 31.5H16.7344V21.5156H19.8281V31.5ZM18.2812 20.1094C17.25 20.1094 16.4531 19.3125 16.4531 18.3281C16.4531 17.3438 17.25 16.5 18.2812 16.5C19.2656 16.5 20.0625 17.3438 20.0625 18.3281C20.0625 19.3125 19.2656 20.1094 18.2812 20.1094ZM31.5 31.5H28.3594V26.625C28.3594 25.5 28.3594 24 26.7656 24C25.125 24 24.8906 25.2656 24.8906 26.5781V31.5H21.7969V21.5156H24.75V22.875H24.7969C25.2188 22.0781 26.25 21.2344 27.75 21.2344C30.8906 21.2344 31.5 23.3438 31.5 26.0156V31.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinHovered);
export default __webpack_public_path__ + "static/media/linkedin_hovered.1a20426ea30a00635a5686377c1bd666.svg";
export { ForwardRef as ReactComponent };